import { bool } from "prop-types";

import ReplyListing from "./ReplyListing.jsx";
import ResponseInterface from "./ResponseInterface.jsx";

const propTypes = {
  userIsLoggedIn: bool.isRequired,
};

const CommentsInterface = (props) => {
  const { userIsLoggedIn } = props;

  return (
    <section className="comments-interface">
      <ResponseInterface
        {...props}
        authenticated={userIsLoggedIn}
        onRestart={() => {}}
      />
      <ReplyListing {...props} />
    </section>
  );
};

CommentsInterface.propTypes = propTypes;
export default CommentsInterface;
